import createVueComponent from '../createVueComponent';

const ArrowUpRight = createVueComponent('ArrowUpRightIcon', [
  ['path', { d: 'M7 7h10v10', key: '1tivn9' }],
  ['path', { d: 'M7 17 17 7', key: '1vkiza' }],
]);

export default ArrowUpRight;
